module.exports = __webpack_public_path__ + "img/face6.5677a60d.png";